export const scrollConfig = {
  behavior: "smooth" as ScrollBehavior,
  top: 0,
  // Weitere Scroll-Optionen können hier hinzugefügt werden
  scrollOffset: 80, // Offset für Anker-Links (z.B. für fixed Header)
};
